import { useTranslation } from 'react-i18next';
import ScreenHeader from '@/components/ScreenHeader';
import { Block } from '@/components/crRender';

const Family = ({ familyHistory }) => {
  const { t } = useTranslation();
  return (
    <div className="family-section">
      <ScreenHeader title="family-history" icon="streamline-color:dna-flat" className="bg-transparent mx-0 px-0" />
      <Block isRender={familyHistory}>
        <div className="family-list">
          {familyHistory}
        </div>
      </Block>
      <Block isRender={!familyHistory}>
        <div className="alert alert-info">{t("no-data")}</div>
      </Block>
    </div>
  );
}

export default Family;